<template>
  <element>
    <nav-breadcrumb :menu="[{label: '账户信息'}]" />
    <el-row>
      <el-col class="grid-content bg-purple">
      <form-build-component
        :form-data="userInfo"
        :form-columns="columns"
        :form-buttons="buttons"
        class="formTable"
      />
      </el-col>
    <el-col class="grid-content bg-purple">

    </el-col>

    </el-row>
  </element>
</template>

<script>
  import NavBreadcrumb from "../../../components/NavBreadcrumb";
  import FormBuildComponent from "../../../components/FormBuild";
  import Status2CN from "../../../filters/Status2CN";
  import xhr from '../../../utils/xhr'

  export default {
    name: "ConfigUserDetail",
    components: {FormBuildComponent, NavBreadcrumb},
    data() {
      return {
        columns: [
          {
            label: '用户名',
            field: 'u__userCode',
            span: 24
          },
          {
            label: '姓名',
            field: 'u__userName',
            span: 24
          },
          {
            label: '部门',
            field: 'd__departmentName',
            span: 24
          },
          {
            label: '状态',
            field: 'u__disabled',
            formatter: function (r,v) {
              return Status2CN(v)
            },
            span: 24
          },
          {
            label: '角色权限',
            field: 'v',
            formatter: function(r,v) {
              return r.detail.map(item=>item.r__roleName).join('，')
            },
            span: 24
          },
            {
                label: '二维码',
                field: 'v',
                component: (r,v)=> {
                    return {
                        template: `<el-image src="/wx/connect/qr" style="width: 200px"></el-image>`,
                        data() {
                            return {
                            }
                        }
                    }
                },
                span: 24
            },
        ],
        buttons: [
          {
            label: '修改密码',
            type: 'primary',
            class: 'el-icon-edit',
            clickHandler: this.changePassword
          }
        ]
      }
    },
    computed: {
      userInfo: function () {
        return this.$store.state.userInfo
      }
    },
    methods: {
      changePassword: function ($refs) {
        $refs.validate(valid=>{
          if(valid) {
            this.$prompt('请输入新密码', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /.{5}/,
              inputErrorMessage: '密码格式不正确，长度大于5位'
            }).then(({value})=>{
              xhr.changePassword(
                {
                  'u.password': value
                },
                res=>{
                  try {
                    if(res.data.status == 'success') {
                      this.$message({
                        type: 'success',
                        message: '修改密码成功！'
                      })
                    }
                    else {
                      this.$message({
                        type: 'error',
                        message: '修改密码失败！'
                      })
                    }
                  }catch (e) {

                  }
                }
              )
            }).catch(()=>{
              this.$message({
                type: 'info',
                message: '取消修改密码'
              })
            })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigUserDetail.vue